import React, { useEffect } from "react"
import Api from '../../utils/api';
import ProductDetail from '../../components-v2/product/ProductDetail';
import StructuredData from "../../components/elements/StructuredDataElement";
import MetaElement from "../../components/elements/MetaElement";
import NotFound from '../../components/NotFound';
import { viewItemEvt } from '../../utils/analytics';
import { track } from '../../utils/kanalytics';

const Produs = (props) => {
    useEffect(() => {
        if (props.product) {
            viewItemEvt(props.product);
            track('product_view', { productId: props.product.id });
        }
    }, [props.product && props.product.id]);

    if(!props.product) {
        return <NotFound />;
    }

    const ogImage = props.product.images && props.product.images[0]
        ? `${process.env.imageStorage}/default_${props.product.images[0].image}.jpg`
        : undefined;

    return (
        <>
            <MetaElement pageId='produs/[slug]' image={ogImage} variables={{
                title: props.product.metaTitle,
                description: props.product.metaDescription
            }}/>
            <StructuredData type="Product" product={props.product}/>
            <ProductDetail key={props.product.id} product={props.product} shipping={props.shipping} related={props.relatedProducts} boughtTogether={props.boughtTogether} breadcrumbs={props.breadcrumbs} drop={props.drop}/>
        </>
    )

}


Produs.getInitialProps = async function(ctx) {
    const slug = ctx.query.slug;
   
    try {
        const apiResponse = await Api.get('/public/product/' + slug, null, null, ctx);

        const product = apiResponse.data.product;
        const breadcrumbs = apiResponse.data.breadcrumbs;
        const relatedProducts = apiResponse.data.relatedProducts;
        const shipping = apiResponse.data.shipping;

        // If no product found, trigger 404
        if (!product) {
            if (ctx.res) {
                ctx.res.statusCode = 404;
            }
            return { product: null };
        }

        // A drop outage must not turn a valid product into a 404. The embedded
        // control retries with the browser session when no initial view exists.
        let drop = null;
        if (product.availability === 'drop' && product.activeDrop?.code) {
            try {
                const response = await Api.get('/v2/drops/public/[code]', { code: product.activeDrop.code }, null, ctx);
                drop = response?.data || null;
            } catch (error) { /* The registration control provides a retry. */ }
        }

        return {
            product,
            relatedProducts,
            boughtTogether: apiResponse.data.boughtTogether || [],
            breadcrumbs,
            shipping,
            drop
        };
    } catch (error) {
        // On API error, trigger 404
        if (ctx.res) {
            ctx.res.statusCode = 404;
        }
        return { product: null };
    }
}

export default Produs;
